import Swiper, { Navigation, Autoplay } from 'swiper';

import 'swiper/css/bundle';

const swiper = new Swiper('.gallery-slider', {
    modules: [Navigation, Autoplay],
    loop: true,
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 10,
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    navigation: {
        nextEl: '.swiper-next-btn',
        prevEl: '.swiper-prev-btn',
    },
            breakpoints: {
            550: {
                slidesPerView: 1.2,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                    slidesPerView: 4,
            },
        },
});


import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';


// Inicjalizacja PhotoSwipe
const lightbox = new PhotoSwipeLightbox({
  gallery: '#gallery-slider',
  children: 'a',
  pswpModule: () => import('photoswipe')
});

lightbox.init();
